import React from 'react'
import { renderReadableDate } from '../common/utils'
import styles from './Callback.module.scss'

export const Callback = ({ created, type, applicationId, status }) => (
  <div className={styles.description} data-type={type} data-status={status}>
    <div>{type}</div>
    <div>{status}</div>
    <div>{renderReadableDate(created)}</div>
    <div>{applicationId}</div>
  </div>
)
